import Text from './text'

export default function select(input) {
  let field = Text(input)
  let { data, multiple = false } = input
  // if array only is strings
  if (typeof data[0] !== 'object') {
    data = data.map((option, index) => {
      return {
        key: option,
        value: option,
        index,
        selected: false
      }
    })
  } else {
    data = data.map((option, index) => {
      return {
        ...option,
        index,
        selected: false
      }
    })
  }
  return {
    ...field,
    options: data,
    value: [],
    isMultiple: multiple,
    isValue: [`minLength:${field.isRequired ? 1 : 0}`]
  }
}



// WEBPACK FOOTER //
// ./src/modules/app/helpers/select.js